import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';

export const ProductNavigationLink = styled.div`
  min-width: calc(25vw - 2.3rem);
  max-width: 8rem;
  ${media.mediumUp`
    max-width: 8rem;
    min-width: 7.5rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  `}

  ${media.largeUp`
    max-width: 12.5rem;
  `}
`;
